// extracted by mini-css-extract-plugin
export var contentBody = "_5d-9";
export var headerImage = "_5d-2";
export var imageButton = "_5d-7";
export var imageButtonIcon = "_5d-8";
export var imageHeader = "_5d-4";
export var imageHeaderText = "_5d-5";
export var imageOverlay = "_5d-3";
export var imageTitle = "_5d-6";
export var imageWrapper = "_5d-1";
export var taskList = "_5d-a";
export var widget = "_5d-0";